export const pageTitle = (title) => {
  return ( document.title = "Vishal Web Tech | Best Digital Marketing Agency in Delhi");
}